export default __webpack_public_path__ + "media/images/spinningwheel/sw-button-cancel-139af2e3e9245a695f4eac4942917e8d.png";